<template>
    <div v-if="globalLoading" class="prelative">
        <preloader :display="true" />
    </div>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue'
    import { createNamespacedHelpers } from 'vuex';
    const {mapState}  = createNamespacedHelpers('system');

    export default {
        computed: {
            ...mapState({
                globalLoading: 'globalLoading',
            }),
        },
        components: {
            Preloader
        }
    }
</script>

<style scoped>

</style>